import { gql } from '@apollo/client';

export const setPaymentAttempt = gql`mutation PaymentAttempt($id: String!) {
    paymentAttempt(id: $id)
  }
`;